// Opening one conversation by its address.
//
// Two spellings are in circulation and neither can be withdrawn: every
// notification mail the server has ever sent links with taskId, as does the
// task card, while the admin task list links with task. Reading only one of
// them sent those links to the task list instead of the conversation they
// named.
export const CHAT_PATH = "/chat";

export const taskIdFromSearch = (search) => {
  const params = new URLSearchParams(search || "");
  const id = params.get("taskId") || params.get("task");
  return id && id.trim() ? id.trim() : null;
};

// What a desktop notification points at. It used to point at "chat", with no
// id and no leading slash, so it opened the task list in a second tab.
export const chatLinkFor = (taskId) =>
  taskId ? `${CHAT_PATH}?taskId=${encodeURIComponent(taskId)}` : CHAT_PATH;
